import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const MailPromo = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 32 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <g clipPath="url(#clip0_6988_443)">
        <path
          d="M0.621804 19.9604L5.73979 8.50072C14.375 13.4136 20.229 13.9525 29.7969 14.4212L23.9934 30.904C14.3117 28.6604 8.16896 25.3715 0.621804 19.9604Z"
          fill="#FB6434"
          stroke="black"
          strokeWidth="1.4"
        />
        <path
          d="M4.98483 10.822C7.29139 15.3631 9.74211 19.5436 12.6253 23.5801C18.3917 22.0665 22.6444 20.1203 28.7712 17.0209"
          stroke="black"
          strokeWidth="1.4"
        />
        <path
          d="M20.4617 4.1597L20.6804 4.45995L21.0516 4.44719L23.4609 4.36439L23.6013 6.77106L23.623 7.14186L23.9421 7.33183L26.0138 8.56476L24.8307 10.6653L24.6485 10.9889L24.8143 11.3213L25.8905 13.4785L23.7596 14.606L23.4313 14.7797L23.3911 15.1489L23.1302 17.5455L20.728 17.342L20.3579 17.3106L20.1244 17.5995L18.6092 19.4746L16.6985 18.0046L16.4041 17.7782L16.0515 17.895L13.7631 18.6532L12.9503 16.3836L12.8251 16.0339L12.4653 15.9416L10.1303 15.3422L10.6736 12.9935L10.7573 12.6316L10.5046 12.3594L8.86423 10.5928L10.5911 8.91066L10.8572 8.65148L10.7918 8.28586L10.3669 5.91283L12.7291 5.43137L13.0931 5.35719L13.2357 5.01422L14.1612 2.78822L16.4087 3.66029L16.755 3.79465L17.0604 3.58322L19.0425 2.21098L20.4617 4.1597Z"
          fill="#FFDB59"
          stroke="black"
          strokeWidth="1.4"
        />
        <path d="M21.2568 7.75183L13.9128 13.8718" stroke="black" strokeWidth="1.4" />
        <circle cx="15.7488" cy="8.36377" r="1.224" fill="black" />
        <circle cx="19.4208" cy="13.2599" r="1.224" fill="black" />
      </g>
      <defs>
        <clipPath id="clip0_6988_443">
          <rect width="32" height="32" fill="white" transform="translate(0 0.246826)" />
        </clipPath>
      </defs>
    </svg>
  )
})

export default MailPromo
